import { Observable } from 'rxjs';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AzureService {

  constructor(private _httpClient: HttpClient) {}

  getAzureGroups(token: string): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', `Bearer ${token}`);
    return this._httpClient.get('https://graph.microsoft.com/v1.0/groups?$top=999', {
      headers: headers,
    });
  }
}
